/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import DropDown from 'app/components/common/DropDown.jsx';
import NotificationHeader from 'app/components/DropDownItems/NotificationHeader.jsx';
import NotificationItem from 'app/components/DropDownItems/NotificationItem.jsx';
import * as _ from 'underscore';

const navigation = [
    {
        link: '/content/feed',
        label: 'Content',
        iconClass: 'ds-icon icon-add-content',
        subSections: [
            {
                iconClass: 'fa fa-share',
                label: 'Add Feed',
                link: '/content/feed'
            },
            {
                iconClass: 'icon ion-ios-bolt-outline',
                label: 'Import/Discover',
                link: '/content/import'
            },
            {
                iconClass: 'icon ion-log-in',
                label: 'WP Connections',
                link: '/content/connections'
            },
            {
                iconClass: 'icon ion-ios-upload-outline',
                label: 'Import CSV',
                link: '/content/csv'
            }
        ]
    },
    {
        link: '/share/automate',
        label: 'Automate',
        iconClass: 'fa fa-share icon',
        subSections: [
            {
                iconClass: 'fa fa-share',
                label: 'Automations',
                link: '/share/automations'
            },
            {
                iconClass: 'fa fa-share',
                label: 'My Feeds',
                link: '/share/automate'
            },
            {
                iconClass: 'icon ion-wand',
                label: 'Curated',
                link: '/share/curate'
            }
        ]
    },
    {
        link: '/queue',
        label: 'Schedule',
        iconClass: 'icon ion-android-calendar',
        subSections: [
            {
                iconClass: 'fa fa-list',
                label: 'Queue',
                link: '/queue/detail/:currentSocial:',
            },
            {
                iconClass: 'icon ion-android-alarm-clock',
                label: 'Posting Times',
                link: '/queue/schedule/:currentSocial:'
            },
            {
                iconClass: 'ds-icon icon-everqueue',
                label: 'EverQueue',
                link: '/queue/everqueue/:currentSocial:'
            },
            {
                iconClass: 'icon ion-android-calendar sidebar-icon',
                label: 'Calendar',
                link: `/queue/calendar/:currentSocial:`,
            },
            {
                iconClass: 'icon ion-ios-pricetag-outline',
                label: 'Categories',
                link: '/queue/categories'
            },
            {
                iconClass: 'icon ion-ios-gear-outline',
                label: 'Social Settings',
                link: `/config/socials/detail/:currentSocial:`,
            },
        ]
    },
    {
        link: '/stats',
        label: 'Stats',
        iconClass: 'fa fa-bar-chart icon'
    },
    {
        link: '/config/socials',
        label: 'Socials',
        iconClass: 'fa fa-paper-plane icon',
        subSections: [
            {
                iconClass: 'fa fa-paper-plane',
                label: 'Social Accounts',
                link: '/config/socials',
                whichBadge: 'socials'
            },
            {
                iconClass: 'fa fa-link',
                label: 'Short Links',
                link: '/config/shorteners'
            }
        ]
    },
    {
        link: '/people',
        label: 'People',
        iconClass: 'fa fa-users icon',
        subSections: [
            {
                iconClass: 'fa fa-user-plus',
                label: 'Team',
                link: '/people/team'
            },
            {
                iconClass: 'fa fa-briefcase',
                label: 'Clients',
                link: '/people/clients'
            },
        ]
    }
];

const accountNav = [
    { link: '/account', iconClass: 'fa fa-user', label: 'Account Info' },
    { link: '/account/subscription', iconClass: 'fa fa-rocket', label: 'Your Plan' },
    { link: '/account/billing', iconClass: 'fa fa-credit-card', label: 'Billing Info' },
    { link: '/account/invoices', iconClass: 'fa fa-usd', label: 'Payment History' },
    { link: '', iconClass: 'fa fa-life-ring', label: 'Support' },
    { link: '/signout.php', iconClass: 'fa fa-sign-out', label: 'Sign Out' }
];

const clientNavigation = [
    {
        link: '/socials',
        label: 'Socials',
        iconClass: 'fa fa-users icon',
    }
];

const clientAccountNav = [
    { link: '/account', iconClass: 'fa fa-user', label: 'Account Info' },
    { link: '', iconClass: 'fa fa-life-ring', label: 'Support' },
    { link: '/signout.php', iconClass: 'fa fa-sign-out', label: 'Sign Out' }
];

class MobileNav extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            menuActive: false,
            accountMenuActive: false,
            notificationShow: false,
            allClear: false
        };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleAccountMenu = this.toggleAccountMenu.bind(this);
        this.newPostClick = this.newPostClick.bind(this);
        this.addSocialClick = this.addSocialClick.bind(this);
        this.itemClick = this.itemClick.bind(this);
        this.notificationToggle = this.notificationToggle.bind(this);
        this.toggleAllClear = this.toggleAllClear.bind(this);
        this.onUpgrade = this.onUpgrade.bind(this);
        this.sendPromoView = this.sendPromoView.bind(this);

    }

    componentDidMount() {
        // need to set the link from within the object to have access to the config object
        accountNav[4].link = this.props.app.config.supportUrl;
        clientAccountNav[1].link = this.props.app.config.supportUrl;
        this.props.getNotices();

        if (!_.isEmpty(this.props.user.perms)) {
            this.sendPromoView(this.props);
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.router.location && !this.props.router.location.pathname.match(/subscription/)) {
            if (_.isEmpty(prevProps.user.perms) && !_.isEmpty(this.props.user.perms)) {
                this.sendPromoView(this.props);
            }
        }

        if (prevProps.app.loading.NOTIFICATIONS_CLEAR === true && this.props.app.loading.NOTIFICATIONS_CLEAR === false) {
            this.props.getNotices();
        }

    }

    sendPromoView(props) {
        let creative = (parseInt(props.user.detail.pubLevel, 10) > 1) ? 'upgrade_button.upgrade.mobile.' : 'upgrade_button.new.mobile.',
            version = '',
            onboarding = (typeof (Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

        if (this.props.router.location &&
            !this.props.router.location.pathname.match(/subscription/) &&
            !this.props.router.location.pathname.match(/account\/billing/) &&
            onboarding === null) {
            if (dataLayer && parseInt(props.userId, 10) !== 0) {
                if (parseInt(props.user.detail.pubLevel, 10) > 1) {
                    version = ".power";
                } else {
                    //version = (parseInt(props.userId, 10) % 2) ? "trial-100%" : "trial-90%";
                }

                if (this.state.plusTrialAvailable) {
                    creative += version + ".plus";
                } else {
                    creative += version;
                }

                // dataLayer.push({
                // 	'event': 'promotionView',
                // 	'ecommerce': {
                // 		'promoView': {
                // 			'promotions': [
                // 				{
                // 					'id': 'upgrade_button_mobile',
                // 					'name': 'Mobile Upgrade Button',
                // 					'creative': creative,
                // 					'position': 'nav_banner'
                // 				}
                // 			]
                // 		}
                // 	},
                //     // GA4 promo view params
                //     'promotion_id': 'upgrade_button_mobile',
                //     'promotion_name': 'Mobile Upgrade Button',
                //     'creative_name': creative,
                //     'creative_slot': 'nav_banner',
                //     items: [
                //         {
                //             item_id: 'dlvrit_1',
                //             item_name: 'dlvr.it premium plan',
                //             price: 1.00,
                //             quantity: 1
                //         }
                //     ]
                // });

                if (gtag) {
                    gtag('event', 'view_promotion', {
                        'promotion_id': 'upgrade_button_mobile',
                        'promotion_name': 'Mobile Upgrade Button',
                        'creative_name': creative,
                        'creative_slot': 'nav_banner',
                        items: [
                            {
                                item_id: 'dlvrit_1',
                                item_name: 'dlvr.it premium plan',
                                price: 1.00,
                                quantity: 1
                            }
                        ]
                    });
                }

                if (mixpanel) {
                    mixpanel.track("Mobile Upgrade Button View", {
                        creative: creative,
                        pubLevel: props.user.detail.pubLevel
                    });
                }

                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Mobile Upgrade Button View',
                        event_data: {
                            button: creative
                        }
                    });
                }
            }
        }
    }

    toggleAccountMenu(e) {
        let accountMenuActive = !this.state.accountMenuActive;
        e.preventDefault();

        this.setState({
            accountMenuActive,
            menuActive: false,
        });

    }

    toggleMenu(e) {
        let menuActive = !this.state.menuActive;
        e.preventDefault();

        this.setState({
            menuActive,
            accountMenuActive: false,
        });

    }

    itemClick(e) {
        let link = e.currentTarget.dataset.link;

        e.preventDefault();
        // for sublinks stop the parent event from firing
        e.stopPropagation();

        this.setState({
            menuActive: false,
            accountMenuActive: false,
        });

        if (link.match("php") || link.match(/^https\:\/\//)) {
            window.location = link;
        } else {
            this.props.router.navigate(link);
        }


    }

    newPostClick(e) {
        e.preventDefault();

        this.setState({
            menuActive: false,
        });

        this.props.router.navigate('/content/post');

    }

    addSocialClick(e) {
        let appUrl = this.props.app.config.appUrl,
            modal = (
                <SocialModal
                    {...this.props}
                    setModal={this.props.closeAllModals}
                    router={this.props.router}
                    context={'config'}
                    recordPath={this.props.recordPath}
                    redirect={appUrl + "/config/socials"} />
            );

        this.setState({
            menuActive: false,
        });

        this.props.addModal(modal);

    }

    notificationToggle() {
        let notificationShow = this.state.notificationShow ? false : true;

        this.setState({
            notificationShow
        });
    }

    toggleAllClear(e) {
        let allClear = this.state.allClear ? false : true;

        if (allClear) {
            window.setTimeout(() => {
                this.toggleAllClear();
            }, 1000);
        }

        this.setState({
            allClear
        });
    }

    onNoticeMouseOut(e) {
        if (e.currentTarget.className === "icon-wrap" && (e.relatedTarget && e.relatedTarget.className === "notification-all-clear")) {
            return;
        }

        this.setState({
            allClear: false
        });
    }

    onUpgrade(e) {

        e.preventDefault();

        let that = this,
            redirector = function () {
                // if (!that.props.trialEligible && !that.props.isFreeUser()) {
                // 	if (that.props.isProUser()) {
                // 		that.props.router.navigate('/account/subscription/plus');
                // 		return;
                // 	}
                // }
                if (that.props.isFreeUser()) {
                    that.props.router.navigate('/account/subscription/new?plan=6');
                } else {
                    that.props.router.navigate('/account/subscription');
                }
            };

        if (dataLayer || mixpanel) {
            let creative = '';

            // ternary operator breaking in firefox for some reason...
            if (parseInt(this.props.user.detail.pubLevel, 10) > 1) {
                creative = 'upgrade_button.upgrade.mobile.';
                creative += 'power';
            } else {
                creative = 'upgrade_button.new.mobile';
                //creative += (parseInt(this.props.userId, 10) % 2) ? "trial-100%" : "trial-90%";
            }

            if (mixpanel) {
                mixpanel.track("Mobile Upgrade Button Click", {
                    creative: creative,
                    pubLevel: this.props.user.detail.pubLevel
                });
            }

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Mobile Upgrade Button Click',
                    event_data: {
                        button: creative
                    }
                });
            }

            if (gtag) {
                gtag('event', 'select_promotion', {
                    // GA4 promo view params
                    'promotion_id': 'upgrade_button',
                    'promotion_name': 'Upgrade Button',
                    'creative_name': creative,
                    'creative_slot': 'nav_banner',
                    items: [
                        {
                            item_id: 'dlvrit_1',
                            item_name: 'dlvr.it premium plan',
                            price: 1.00,
                            quantity: 1
                        }
                    ]
                });

                this.props.persistData('gaPromo', {
                    promotion_id: 'upgrade_button',
                    promotion_name: 'Upgrade Button'
                });
            }

            // if (dataLayer && window.ga && ga.loaded) {
            // 	dataLayer.push({
            // 		'event': 'promotionClick',
            // 		'ecommerce': {
            // 			'promoClick': {
            // 				'promotions': [
            // 					{
            // 						'id': 'upgrade_button_mobile',
            // 						'name': 'Mobile Upgrade Button',
            // 						'creative': creative,
            // 						'position': 'nav_banner'
            // 					}
            // 				]
            // 			}
            // 		},
            // 		'eventCallback': function() {
            // 			// if (!that.props.trialEligible && !that.props.isFreeUser()) {
            // 			// 	if (that.props.isProUser()) {
            // 			// 		that.props.router.navigate('/account/subscription/plus');
            // 			// 		return;
            // 			// 	}
            // 			// }
            // 			that.props.router.navigate('/account/subscription');
            // 		},
            //         // GA4 promo view params
            //         'promotion_id': 'upgrade_button_mobile',
            //         'promotion_name': 'Mobile Upgrade Button',
            //         'creative_name': creative,
            //         'creative_slot': 'nav_banner',
            //         items: [
            //             {
            //                 item_id: 'dlvrit_1',
            //                 item_name: 'dlvr.it premium plan',
            //                 price: 1.00,
            //                 quantity: 1
            //             }
            //         ]
            // 	});
            // } else {
            // 	redirector();
            // }

            redirector();

        }


    }

    render() {
        let constants = this.props.app.config.constants,
            logoUrl = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100.png'].join(''),
            logoUrl2X = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100@2x.png'].join(''),
            section = 'Feeds',
            iconClass = "notice-warning",
            notificationButton = null,
            notificationHeader = null,
            notifications = null,
            userImage = (
                <div className="mobile-user-image" onClick={this.toggleAccountMenu} role="button" aria-label="view account">
                    <img src={this.props.user.detail.avatar} className="user-img" />
                </div>
            ),
            upgradeButton = null,
            showUpgrade = true,
            onboarding = (typeof (Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
            navItems = (this.props.appName === "dlvr") ? navigation : clientNavigation,
            accountNavItems = (this.props.appName === "dlvr") ? accountNav : clientAccountNav;

        if (this.props.router.location.pathname.match("content")) {
            section = 'Content';
        } else if (this.props.router.location.pathname.match("queue")) {
            section = 'Queue';
            if (this.props.router.location.pathname.match("everqueue")) {
                section = "EverQueue";
            } else if (this.props.router.location.pathname.match("categories")) {
                section = "Categories";
            }
        } else if (this.props.router.location.pathname.match("stats")) {
            section = 'Stats';
        } else if (this.props.router.location.pathname.match(/socials?/)) {
            section = 'Socials';
        } else if (this.props.router.location.pathname.match("shorteners")) {
            section = 'Shorteners';
        } else if (this.props.router.location.pathname.match("team")) {
            section = 'Team';
        } else if (this.props.router.location.pathname.match("account")) {
            section = 'Account';
        } else if (this.props.router.location.pathname.match("curate")) {
            section = 'Curation';
        }

        if (this.state.notificationShow) {
            notificationHeader = (
                <NotificationHeader
                    {...this.props}
                    count={this.props.notifications.length} />
            );
            notifications = (
                <DropDown id="notices"
                    {...this.props}
                    items={this.props.notifications}
                    itemElement={NotificationItem}
                    dropDownClass="notification-dd"
                    clickHandler={this.notificationToggle}
                    listHeader={notificationHeader}
                    resetHandler={this.notificationToggle} />
            );
        }

        if (this.props.notifications && this.props.notifications.length) {
            // look for terminal notices
            if (_.where(this.props.notifications, { type: "10" }).length) {
                iconClass = "notice-terminal";
            }
            notificationButton = (
                <div className="mobile-notices" onClick={this.notificationToggle} role="button" aria-label="view notifications">
                    <i className={"fa fa-bell " + iconClass}></i>
                    <span className="nav-alert-badge">{this.props.notifications.length}</span>
                </div>
            );
        } else {
            notificationButton = (
                <div className="mobile-notices" onClick={this.toggleAllClear} role="button" aria-label="clear notifications">
                    <i className="fa fa-bell notice-all-clear"></i>
                </div>
            );
        }

        if (this.state.allClear) {
            notifications = (
                <div className="notification-all-clear" onClick={this.toggleAllClear}>
                    No new notifications
                </div>
            );
        }

        if (this.props.appName === "dlvr" && this.props.router.location &&
            !this.props.router.location.pathname.match(/subscription/) &&
            !this.props.router.location.pathname.match(/account\/billing/) &&
            onboarding === null) {
            upgradeButton = (
                <div className="upgrade-button-mobile" onClick={this.onUpgrade} role='button' aria-label='upgrade'>
                    <i className="ds-icon icon-upgrade-mobile"></i>
                </div>
            );
        } else {
            upgradeButton = (
                <div className="upgrade-button-mobile empty"></div>
            );
        }

        return (
            <div className="mobile-header" aria-hidden={this.props.modals.stack.length ? true : false}>
                <div className="id-block">
                    <div className="mobile-logo-wrapper">
                        <Link to={this.props.appName === "dlvr" ? "/share/automate" : "/socials"}>
                            <img
                                src={logoUrl}
                                srcSet={`${logoUrl} 1x, ${logoUrl2X} 2x`}
                                width="110px"
                                height="36px"
                                className="nav-logo" />
                        </Link>
                    </div>
                    <div className="account-wrapper">
                        {upgradeButton}
                        {notificationButton}
                        {userImage}
                        {notifications}
                    </div>
                </div>
                <div className="menu-status-block">
                    <div className="menu-trigger" onClick={this.toggleMenu} role="button" aria-label="show notifications">
                        <i className="icon ion-navicon-round"></i>
                    </div>
                    <div className="section-title">
                        {section}
                    </div>
                </div>
                <AnimatePresence>
                    {this.state.accountMenuActive && (
                        <motion.ul
                            className="mobile-account-list"
                            key="account-menu"
                            initial={{
                                top: "-246px"
                            }}
                            animate={{
                                top: "57px"
                            }}
                            exit={{
                                top: "-246px"
                            }}
                            transition={{
                                duration: 0.8,
                                ease: "easeOut"
                            }}>
                            {accountNavItems.map((item, i) => {
                                return (
                                    <li key={'account-item-' + i} className="mobile-account-item" data-link={item.link} onClick={this.itemClick} role="button" aria-label={item.label}>
                                        <div className="mobile-account-icon-wrapper">
                                            <i className={item.iconClass}></i>
                                        </div>
                                        <span className="mobile-account-item-label">
                                            {item.label}
                                        </span>
                                    </li>
                                );
                            })}
                        </motion.ul>
                    )}
                    {this.state.menuActive && (
                        <motion.div
                            className="site-navigation"
                            key="site-nav"
                            initial={{
                                left: "-100vw"
                            }}
                            animate={{
                                left: 0
                            }}
                            exit={{
                                left: "-100vw"
                            }}
                            transition={{
                                duration: 0.8,
                                ease: "easeOut"
                            }}>
                            <div className="action-buttons">
                                {this.props.appName === "dlvr" ? (
                                    <div className="action-button">
                                        <button onClick={this.newPostClick} className="">
                                            New Post
                                        </button>
                                    </div>
                                ) : null}
                                <div className="action-button">
                                    <button onClick={this.addSocialClick} className="">
                                        Add Social
                                    </button>
                                </div>
                            </div>
                            <ul className="mobile-nav-list">
                                {navItems.map((navItem, i) => {
                                    let subSections = null;

                                    if (navItem.subSections !== undefined) {
                                        subSections = (
                                            <ul className="mobile-nav-subs-list">
                                                {navItem.subSections.map((section, i) => {
                                                    let badge = null,
                                                        badgeData = 0,
                                                        link = section.link,
                                                        currentSocial = 0;

                                                    if (section.whichBadge !== undefined) {
                                                        if (section.whichBadge === 'socials') {
                                                            badgeData = this.props.socials.list.length;
                                                        }
                                                        badge = (
                                                            <span className="mobile-nav-badge">
                                                                {badgeData}
                                                            </span>
                                                        );
                                                    }

                                                    if (link.match(':currentSocial:')) {
                                                        if (this.props.router.params.socialId) {
                                                            currentSocial = this.props.router.params.socialId;
                                                        } else {
                                                            for (let i = 0; i < this.props.socials.list.length; ++i) {
                                                                if (parseInt(this.props.socials.list[i].activeFlag, 10)) {
                                                                    currentSocial = this.props.socials.list[i].id;
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                        if (currentSocial) {
                                                            link = link.replace(":currentSocial:", currentSocial);
                                                        } else {
                                                            link = '/queue';
                                                        }
                                                    }

                                                    return (
                                                        <li key={'subsection-' + i} className="mobile-nav-section-item sub" onClick={this.itemClick} data-link={link} role="button" aria-label={section.label}>
                                                            <div className="mobile-nav-icon-wrapper">
                                                                <i className={section.iconClass}></i>
                                                            </div>
                                                            <span className="section-label">{section.label}</span>
                                                            {badge}
                                                        </li>
                                                    );

                                                })}
                                            </ul>
                                        );
                                    }

                                    return (
                                        <li key={'section-' + i} className="mobile-nav-section-item top" onClick={this.itemClick} data-link={navItem.link} role="button" aria-label={navItem.label}>
                                            <div className="mobile-nav-icon-wrapper">
                                                <i className={navItem.iconClass}></i>
                                            </div>
                                            <span className="section-label">{navItem.label}</span>
                                            {subSections}
                                        </li>
                                    );
                                })}
                            </ul>
                        </motion.div>
                    )}
                </AnimatePresence>

            </div>
        );
    }
}

MobileNav.displayName = "MobileNav";

MobileNav.propTypes = {
    appName: PropTypes.string
};

MobileNav.defaultProps = {
    appName: "dlvr"
};

export default MobileNav;
